/* eslint-disable import/order */
import Helmet from 'react-helmet';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import 'react-dates/initialize';

import NiceModal from '@ebay/nice-modal-react';
import { App as AntApp, ConfigProvider } from 'antd';
import { THEME_CONFIG } from 'Constants/theme';

import '../styles/style.less';
import Routes from './routes';

import store, { persistor } from './redux/createStore';

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <NiceModal.Provider>
          <ConfigProvider theme={THEME_CONFIG}>
            <AntApp style={{ height: '100%' }}>
              <Helmet title="" titleTemplate="%s - ManaDr Dashboard">
                <html lang="en" />
              </Helmet>
              <Routes />
            </AntApp>
          </ConfigProvider>
        </NiceModal.Provider>
      </PersistGate>
    </Provider>
  );
};

export default App;
